<button class="ajin-button-footer" (click)="click.emit()">
    <ng-content select="mat-icon"></ng-content>
    <ng-content select="span"></ng-content>
    <ng-content></ng-content>
</button>
